<template>
    <div :class="`wf-button ${plain ? 'wf-button-plain' : ''}`" @click="handleClick">
        <slot></slot>
    </div>
</template>

<script>
export default {
    data() {
        return {

        }
    },
    props: {
        plain: {
            type: Boolean,
            default: false
        }
    },
	methods: {
		// 按钮点击时触发
		handleClick(event) {
			this.$emit('click', event)
		}
    }
}
</script>

<style lang="scss" scoped>
.wf-button {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 30px;
    border-radius: 4px;
    font-size: 13px;
    color: #fff;
    background-color: #0061E4;
    transition: background-color 0.15s;
    cursor: pointer;
    user-select: none;
}

.wf-button:hover {
    background-color: #006DFF;
}
.wf-button:active {
    background-color: #0054C5;
}

.wf-button-plain {
    border: 1px solid #E0E0E0;
    background-color: #fff;
    color: #666666;
}

.wf-button-plain:hover {
    background-color: rgba(0, 109, 255, 0.03);
}
.wf-button-plain:active {
    background-color: rgba(0, 85, 196, 0.05);
}
</style>


// WEBPACK FOOTER //
// src/components/button/button.vue